import React from 'react'
import { NO_ACTIVITIES_PROPS } from 'app/constants/favoriteActivities'
import FavoriteActivity from './FavoriteActivity'
import FavoriteActivitiesNoActivities from 'app/components/NoActivitiesComponent'
import FavoriteActivitiesLoader from 'app/domains/common/Loaders/FavoriteActivitiesLoader'

const FavoriteActivitiesList = ({ list, size, pendingGetAll, removeFromFavorites }) => {
  return (
    <div className="favorite-activities-list">
      {pendingGetAll ? (
        <FavoriteActivitiesLoader />
      ) : size ? (
        list.map((favoriteActivity, i) => (
          <FavoriteActivity
            key={i}
            favoriteActivity={favoriteActivity.toJS()}
            removeFromFavorites={() => removeFromFavorites({ activityId: favoriteActivity.get('activityId') })}
          />
        ))
      ) : (
        <FavoriteActivitiesNoActivities {...NO_ACTIVITIES_PROPS} />
      )}
    </div>
  )
}

export default FavoriteActivitiesList
